export const PREVIEW_HEIGHT = 105;

export const PREVIEW_MIN_SELECTION_LENGTH = 5 * 60 * 1000; // 5 minutes
